module.exports = __webpack_public_path__ + "img/emblem.7b21bf19.png";